"use client";
import ModernPreloader from "../(components)/shared/ModernPreloader";

export default function Loading() {
  return <ModernPreloader />;
}
